import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, HelpCircle } from 'lucide-react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import SectionTitle from '../ui/SectionTitle';
import SEO from '../seo/SEO';
import { getAllQuizzes } from '../../lib/quizzes';
import { stagger, fadeInUp } from '../../lib/animations';

const QuizList: React.FC = () => {
  const quizzes = getAllQuizzes();

  return (
    <>
      <SEO
        title="Quizzes Automotivos e Testes de Personalidade – Gas2"
        description="Divirta-se com os nossos quizzes automotivos estilo Buzzfeed! Faça o teste de personalidade e descubra qual carro brasileiro mais combina com você."
      />

      <Navbar solid />

      <main className="min-h-screen bg-slate-950 pt-24 pb-20">
        <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mb-16">
          <SectionTitle
            eyebrow="Quizzes Gas2"
            title="Testes de Personalidade"
            subtitle="Descubra o seu lado automotivo! Faça nossos quizzes divertidos, descubra sua personalidade nas pistas e compartilhe os resultados com seus amigos no WhatsApp."
            align="center"
            dark
          />
        </section>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 grid gap-8 sm:grid-cols-2"
        >
          {quizzes.map((quiz) => (
            <motion.div
              key={quiz.slug}
              variants={fadeInUp}
              className="group flex flex-col overflow-hidden rounded-2xl bg-slate-900 border border-slate-800 hover:border-amber-400/40 transition-colors duration-300"
            >
              {quiz.thumbnailUrl && (
                <div className="overflow-hidden aspect-video">
                  <img
                    src={quiz.thumbnailUrl}
                    alt={quiz.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
              )}
              <div className="flex flex-col flex-1 p-6">
                <div className="flex items-center gap-1.5 mb-3">
                  <span className="flex h-5 w-5 items-center justify-center rounded bg-amber-400/10">
                    <HelpCircle className="h-3.5 w-3.5 text-amber-400" strokeWidth={1.8} />
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-wide text-amber-400">
                    Teste de Personalidade
                  </span>
                </div>

                <h2 className="font-display text-xl font-bold text-white group-hover:text-amber-400 transition-colors duration-200 leading-snug mb-2">
                  {quiz.title}
                </h2>

                <p className="text-slate-400 text-sm leading-relaxed mb-6 flex-1">
                  {quiz.tldr}
                </p>

                <Link
                  to={`/quiz/${quiz.slug}`}
                  className="flex items-center gap-1.5 text-amber-400 hover:text-amber-300 font-semibold transition-colors shrink-0"
                >
                  Fazer o teste
                  <ArrowRight className="h-4 w-4" strokeWidth={2} />
                </Link>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </main>

      <Footer />
    </>
  );
};

export default QuizList;
